import { ClipboardDocumentCheckIcon, PresentationChartBarIcon, ScaleIcon } from '@heroicons/react/20/solid'
import Dashboard from '../../assets/img/home1.png';

const features = [
  {
    name: 'Content at scale',
    description:
      "Simplify the deployment process with Weza Social's push to deploy feature, ensuring quick and seamless updates to your social media platforms.",
    icon: ScaleIcon,
  },
  {
    name: 'Ai Powered',
    description: "Enhance the security of your brand's online presence with Weza Social's SSL certificates, providing a secure connection and peace of mind for your audience",
    icon: ClipboardDocumentCheckIcon,
  },
  {
    name: 'To all your social channels',
    description: "Safeguard your valuable data with Weza Social's automatic database backups, ensuring that your information is protected and easily restorable whenever needed.",
    icon: PresentationChartBarIcon,
  },
]

export default function Schedule() {
  return (
    <div className="overflow-hidden bg-transparent py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          <div className="lg:pr-8 lg:pt-4">
            <div className="lg:max-w-lg">
              <h2 className="text-base font-semibold leading-7 text-white/80">One platform for all brands.</h2>
              <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">Simplify brand management on social media with the most convenient solution.</p>
              <p className="mt-6 text-lg leading-8 text-white">
                Maximize your social media presence with Weza Social's unlimited post scheduling, real-time monitoring of key metrics, and customizable reports for in-depth performance analysis.
              </p>
              <dl className="mt-10 max-w-xl space-y-8 text-base leading-7 text-gray-600 lg:max-w-none">
                {features.map((feature) => (
                  <div key={feature.name} className="relative pl-9">
                    <dt className="inline font-semibold text-white">
                      <feature.icon className="absolute left-1 top-1 h-5 w-5 text-white" aria-hidden="true" />
                      {feature.name}
                    </dt>{' '}
                    <dd className="inline text-white/70">{feature.description}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
          <img
            src={Dashboard}
            alt="Product screenshot"
            className="w-[48rem] max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem] md:-ml-4 lg:-ml-0"
            width={2432}
            height={1442}
          />
        </div>
      </div>
    </div>
  )
}
